module.exports = __webpack_public_path__ + "067f9b18ae4da2f82d5c8c6bc6426abb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/venn_circles.png
// module id = 218
// module chunks = 0